// src/pages/ForgotPasswordPage.jsx

import React, { useState } from "react";
import { forgotPassword } from "../services/authService";
import { Container, Paper, Typography, TextField, Button, Box } from "@mui/material";
import { useSnackbar } from "notistack";
import AuthHeader from "../components/AuthHeader";

function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      setLoading(true);
      const data = await forgotPassword(email);
      enqueueSnackbar(data.message || "Check your inbox", { variant: "success" });
    } catch (err) {
      if (err.response && err.response.data?.error) {
        enqueueSnackbar(err.response.data.error, { variant: "error" });
      } else {
        enqueueSnackbar("Failed to send reset link", { variant: "error" });
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <AuthHeader />
      <Container maxWidth="sm" sx={{ mt: 4 }}>
        <Paper sx={{ p: 3 }} elevation={2}>
          <Typography variant="h5" gutterBottom>
            Forgot Password
          </Typography>
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}
        >
          <TextField
            label="Enter your email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            fullWidth
          />

          <Button
            variant="contained"
            type="submit"
            disabled={loading}
          >
            {loading ? "Processing..." : "Send Reset Link"}
          </Button>
        </Box>
      </Paper>
    </Container>
    </>
  );
}

export default ForgotPasswordPage;